import { action } from 'satcheljs/lib/legacy';
import listViewStore from '../store/Store';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';

export default action('createFocusedOtherDropViewState')(
    function createFocusedOtherDropViewState() {
        listViewStore.focusedOtherDropViewState = createDropViewState();
    }
);
